import { render, staticRenderFns } from "./SummaryRegistrationForm.vue?vue&type=template&id=84c9ad92"
import script from "./SummaryRegistrationForm.vue?vue&type=script&lang=js"
export * from "./SummaryRegistrationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports